module.exports = __webpack_public_path__ + "img/logo.8bd40a66.png";